import type { Periodo, StatoDichiarazione } from '@praticheenergia/domain'

export const ETICHETTA_PERIODO: Record<Periodo, string> = {
  annuale: 'annuale',
  semestre_1: 'I semestre',
  semestre_2: 'II semestre',
}

export const ETICHETTA_STATO_DICHIARAZIONE: Record<StatoDichiarazione, string> = {
  letture_non_inserite: 'Letture non inserite',
  bozza: 'Bozza',
  letture_da_controllare: 'Letture da controllare',
  da_firmare: 'Da firmare',
  da_inviare: 'Da Inviare',
  inviata: 'Inviata',
  errore_invio: 'Errore di invio',
}

export const TRANSIZIONI_DICHIARAZIONE: Record<StatoDichiarazione, StatoDichiarazione[]> = {
  letture_non_inserite: ['bozza'],
  bozza: ['letture_non_inserite', 'letture_da_controllare', 'da_firmare'],
  letture_da_controllare: ['bozza', 'da_firmare'],
  da_firmare: ['bozza', 'da_inviare'],
  da_inviare: ['da_firmare', 'inviata', 'errore_invio'],
  // La rettifica riapre in bozza (0041_rettifica.sql): e' l'unico stato in cui
  // letture, vendite e formule tornano modificabili. Da li' si rigenera l'XML,
  // lo si firma di nuovo e si ritrasmette.
  inviata: ['bozza'],
  errore_invio: ['da_inviare', 'da_firmare'],
}

export function puoTransire(da: StatoDichiarazione, a: StatoDichiarazione): boolean {
  return TRANSIZIONI_DICHIARAZIONE[da].includes(a)
}
